import React from "react";
import {Form, Input} from "antd";
import CommentEditor from "../../../../widget/optionEditor/CommentEditor";
import ICommentOptions from "../../../../../../../model/interface/widget/option/ICommentOptions";
import IContentType from "../../../../../../../model/interface/dataStorage/IContentType";
import ThreadsService from "../../../../../../../model/service/comment/ThreadsService";
import FieldPicker from "../../../../../../shared/pickers/FieldPicker";

interface IProps {
    options: ICommentOptions
    contentType: IContentType
}

class CommentCardEditor extends React.Component<IProps, ICommentOptions> {

    static defaultProps = {
        editableLabel: false
    }

    render() {
        const {options, contentType} = this.props

        return (
            <div>
                <Form.Item name={'field'} label={'Pole'}>
                    <FieldPicker serviceClassName={contentType.fullClassName} defaultActiveFirstOption={true} output={'name'} mode={'simple'} allowTargetEntity={[ThreadsService.getRecordClassName()]}/>
                </Form.Item>
                <CommentEditor options={options}/>
            </div>
        )
    }
}

export default CommentCardEditor